import { Dispatch, SetStateAction, useState } from 'react';
import { useAppSelector } from '../../../app/hooks';
import Spinner from '../../../components/common/Spinner';
import { UserPackage } from '../Portfolio.types';
import { ClaimAmount } from './ClaimAmount';
import { ClaimConfirm } from './ClaimConfirm';
import { ClaimWithdrawal } from './ClaimWithdrawal';
import { ClaimWithdrawalFinish } from './ClaimWithdrawalFinish';
import { ClaimStepsEnum } from './types';

interface ClaimProps {
  packageItem: UserPackage | null;
  setClaim: Dispatch<SetStateAction<boolean>>;
  claimStep: ClaimStepsEnum;
  setClaimStep: Dispatch<SetStateAction<ClaimStepsEnum>>;
}

export const Claim = ({
  packageItem,
  setClaim,
  claimStep,
  setClaimStep
}: ClaimProps) => {
  const [amount, setAmount] = useState('');

  const { loadingAmountToBurn } = useAppSelector((state) => state.portfolio);

  if (loadingAmountToBurn) return <Spinner solid={false} />;

  const claimSteps = (step: ClaimStepsEnum) => {
    switch (step) {
      case ClaimStepsEnum.CONFIRM:
        return <ClaimConfirm setClaimStep={setClaimStep} setClaim={setClaim} />;

      case ClaimStepsEnum.AMOUNT:
        return (
          <ClaimAmount
            packageItem={packageItem}
            setClaimStep={setClaimStep}
            setClaim={setClaim}
            amount={amount}
            setAmount={setAmount}
          />
        );

      case ClaimStepsEnum.WITHDRAWAL:
        return (
          <ClaimWithdrawal
            packageItem={packageItem}
            setClaimStep={setClaimStep}
            setClaim={setClaim}
            amount={amount}
          />
        );

      case ClaimStepsEnum.FINISH:
        return (
          <ClaimWithdrawalFinish
            setClaim={setClaim}
            amount={amount}
            packageItem={packageItem}
          />
        );

      default:
        break;
    }
  };
  return <div>{claimSteps(claimStep)}</div>;
};
